import { Component, OnInit, inject } from '@angular/core';
import { SuggestionEngineService } from '../../../suggestion-engine/suggestion-engine.service';
import { ScoreCard } from '../../../models/suggestion-engine-models';
import { NgxLoadingModule } from 'ngx-loading';
import { MatCardModule } from '@angular/material/card';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-scorecard',
  templateUrl: './scorecard.component.html',
  styleUrls: ['./scorecard.component.scss'],
  imports: [NgxLoadingModule, MatCardModule, CurrencyPipe],
})
export class ScorecardComponent implements OnInit {
  private ses = inject(SuggestionEngineService);

  scData: ScoreCard | null = null;
  state: string = 'loaded';

  ngOnInit() {
    this.ses.getScorecard().subscribe((x: { result: ScoreCard }) => {
      this.scData = x.result;
    });
  }
}
